import { render, staticRenderFns } from "./MySetPassword.vue?vue&type=template&id=68d496c7&"
import script from "./MySetPassword.vue?vue&type=script&lang=js&"
export * from "./MySetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports